<template>
  <div id="app">
    <div class="user-info">
      <div class="user-logo">
        <img src="http://img3.imgtn.bdimg.com/it/u=378824344,1185609431&fm=26&gp=0.jpg" alt />
      </div>
      <div class="user-info-text">
        <div class="user-info-text-info">
          <div class="user-info-mobile-dive">
            <div class="user-mobile">{{ userInfo.mobile }}</div>

            <div v-if="userInfo.viptype == 1 || userInfo.viptype == 5" class="user-mian user-mothod-vip">
              <span>月VIP</span>
            </div>
            <div v-else-if="userInfo.viptype == 2 " class="user-mian user-year-vip">
              <span>年VIP</span>
            </div>
            <div v-else-if="userInfo.viptype == 3 " class="user-mian user-yong-vip">
              <span>永久VIP</span>
            </div>
            <div v-else class="user-mian"><span>免费用户</span></div>
          </div>
          <div class="user-vip-text" v-if="userInfo.viptype == 1 || userInfo.viptype == 2 || userInfo.viptype == 5">
            <span>有效期至{{ validitydate }}</span>
            <button @click="topay">续费</button>
          </div>
          <div class="user-vip-text" v-else-if="userInfo.viptype == 3 ">
            <span>有效期至永久</span>
            <button @click="toVip">私人定制</button>
          </div>
          <div class="user-vip" v-else>
            <span @click="topay">立即升级VIP</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
//接口地址
import api from "../../api/index";
import tips from "@/estoast";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      userInfo: null,
      validitydate: "",
      mobile: null
    };
  },

  created: function() {
    this.userInfo = this.getUserInfo;

    this.validitydate = this.userInfo.validitydateStr;
    console.log("用户信息" + JSON.stringify(this.userInfo));
  },
  watch: {
    getUserInfo: function(newVal, oldVal) {
      console.log(JSON.stringify("userInfo 被修改"));
      // console.log(JSON.stringify(newVal))
      // console.log(JSON.stringify(oldVal))
      this.userInfo = newVal;
      this.validitydate = this.userInfo.validitydateStr;

      console.log("用户信息" + JSON.stringify(this.userInfo));
    }
  },
  mounted() {},
  methods: {
    topay: function() {
      this.$router.push("/pay");
    },
    toVip: function() {
      this.$router.push("/personal");
    },
    changeUserInfo: function() {
      this.$axiosHttp({
        method: "POST",
        url: api.qml.getuserInfo,
        data: { flag: 1 }
      })
        .then(res => {
          if (res.code == 0) {
            //将对应的数据保存到Vuex中
            console.log("有效期：" + res.result.validitydate);
            console.log("有效期：" + res.result.viptype);
            this.userInfo = res.result;
            store.commit(types.SET_USERINFO, res.result);
            store.commit(types.SET_USERLIST, res.result.userRelList);
            this.validitydate = util.formatter(
              this.userInfo.validitydate,
              "yyyy/MM/dd"
            );
            console.log(
              "store里面的userInfo有值" + JSON.stringify(this.userInfo)
            );
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
.user-info {
  width: 704px;
  height: 230px;
  background: linear-gradient(
    143deg,
    rgba(87, 95, 156, 1) 0%,
    rgba(44, 49, 99, 1) 100%
  );
  border-radius: 24px;
  position: relative;
  margin: 0px 22px 0px 24px;
  display: flex;
}

.user-logo {
  width: 110px;
  height: 110px;
  background: linear-gradient(
    143deg,
    rgba(87, 95, 156, 1) 0%,
    rgba(44, 49, 99, 1) 100%
  );
  border-radius: 55px;
  margin: 34px 0px 0px 54px;
  float: left;
}

.user-logo img {
  width: 110px;
  height: 110px;
  background: linear-gradient(
    143deg,
    rgba(87, 95, 156, 1) 0%,
    rgba(44, 49, 99, 1) 100%
  );
  border-radius: 55px;
}

.user-info-text {
  height: 100%;
  float: left;
  margin: 46;
  flex: 1;
}
.user-info-text-info {
  height: 100%;
  float: left;
  margin: 46px 0 0 15px;
}

.user-info-text-info {
  width: 100%;
  float: left;
}

.user-info-mobile-dive {
  width: 100%;
  height: 50px;
}

.user-mobile {
  width: 220px;
  height: 44px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(241, 195, 167, 1);
  line-height: 44px;
  float: left;
}

.user-mian {
  width: 104px;
  height: 32px;
  background: linear-gradient(
    90deg,
    rgba(230, 232, 245, 1) 0%,
    rgba(187, 197, 255, 1) 100%
  );
  border-radius: 14px 14px 14px 4px;
  float: left;
  margin: 6px 0 0 12px;
  line-height: 26px;
}



.user-mothod-vip {
  background: linear-gradient(90deg, #7c8af8 0%, #2e41e5 100%);
  color: #fff5ff;
}
.user-year-vip {
  background: linear-gradient(90deg, #6b6aec 0%, #d769a5 100%);
  color: #fff5ff;
}

.user-yong-vip {
  background: linear-gradient(90deg, #fff0b1 0%, #fbdd51 100%);
  color: #926600;
}

.user-mian span {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(44, 49, 99, 1);
}

.user-vip {
  width: 210px;
  height: 48px;
  background: linear-gradient(
    90deg,
    rgba(238, 176, 142, 1) 0%,
    rgba(249, 220, 193, 1) 100%
  );
  border-radius: 24px;
  margin: 10px 0 0 -1px;
}
.user-vip span {
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 48px;
  text-align: left;
}

.user-vip-text {
  width: 516px;
  height: 34px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(241, 195, 167, 0.9);
  line-height: 44px;
  margin: 0px 0 0 12px;
  text-align: left;
}
.user-vip-text button {
  width: 168px;
  height: 66px;
  background: linear-gradient(
    90deg,
    rgba(238, 176, 142, 1) 0%,
    rgba(249, 220, 193, 1) 100%
  );
  border-radius: 33px;
  font-size: 28px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 40px;
  position: relative;
  border: none;
  margin-left: 110px;
  float: right;
  margin-right: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/centerInfo.vue